import { GET_REPORT, GET_REPORT_SUCCESS, GET_REPORT_ERROR } from '../constants/ActionsTypes'

const initialState = {
  data: {},
  isLoading: {},
  error: null,
}

function rootReducer(state = initialState, action) {
  switch (action.type) {
    case GET_REPORT: {
      const requestKey = action.payload?.reportId || 'default'
      return {
        ...state,
        isLoading: { ...state.isLoading, [requestKey]: true },
        error: null,
      }
    }
    case GET_REPORT_SUCCESS: {
      const successKey = action.reportId || 'default'
      return {
        ...state,
        isLoading: { ...state.isLoading, [successKey]: false },
        data: { ...state.data, [successKey]: action.payload.data },
      }
    }
    case GET_REPORT_ERROR: {
      const errorKey = action.reportId || 'default'
      return {
        ...state,
        isLoading: { ...state.isLoading, [errorKey]: false },
        error: action.payload,
      }
    }

    default:
      return state
  }
}

export default rootReducer
